import React from 'react';
import PropTypes from 'prop-types';
import { TAPlayerItem } from './TAPlayerItem';

/**
 * Maps an array of players into TAPlayerItem components or displays a dash fallback.
 *
 * @param {object} props - Component props.
 * @param {Array} [props.players] - Array of player items.
 * @param {string} props.prefix - Prefix string for keying items.
 * @param {boolean} [props.isAFLW] - Whether the competition is AFLW.
 * @param {string|number} [props.clubId] - Club identifier.
 * @param {string} [props.context] - Team lineups context string.
 * @returns {React.JSX.Element} The list of players or fallback dash.
 */
export const TAPlayerList = ({ players, prefix, isAFLW, clubId, context }) => {
    if (!players?.length) {
        return <span>-</span>;
    }

    return players.map((playerItem, index) => (
        <TAPlayerItem
            key={playerItem?.playerId || playerItem?.player?.playerId || index}
            playerItem={playerItem}
            prefix={prefix}
            index={index}
            total={players.length}
            isAFLW={isAFLW}
            clubId={clubId}
            context={context}
        />
    ));
};

TAPlayerList.propTypes = {
    players: PropTypes.array,
    prefix: PropTypes.string.isRequired,
    isAFLW: PropTypes.bool,
    clubId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    context: PropTypes.string
};
